import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import PhotoPositionIndicator from 'dibs-interiors-photos/exports/PhotoPositionIndicator';
import PhotoContainer from 'dibs-interiors-photos/exports/PhotoContainer';
import PhotoContainerWrapper from 'dibs-interiors-photos/exports/PhotoContainerWrapper';
import PhotosSearchBrowseSocialIcons from './PhotosSearchBrowseSocialIcons';

import { type PhotosSearchBrowsePhotoContainer_photos$key } from './__generated__/PhotosSearchBrowsePhotoContainer_photos.graphql';

type Props = {
    photos: PhotosSearchBrowsePhotoContainer_photos$key | null | undefined;
    modalPhotoIndex: number;
    currentPhotoIndex: number;
    totalResults: number;
    userId: string;
};

const PhotosSearchBrowsePhotoContainer: FC<Props> = ({
    photos: photosRef,
    modalPhotoIndex,
    totalResults,
    currentPhotoIndex,
    userId,
}) => {
    const photos = useFragment(
        graphql`
            fragment PhotosSearchBrowsePhotoContainer_photos on PhotosSearchBrowseQueryConnection {
                ...PhotosSearchBrowseSocialIcons_photos
                edges {
                    node {
                        ...PhotosSearchBrowseSocialIcons_photo
                        id
                        serviceId
                        path
                        url
                        name
                        width
                        height
                        styles {
                            name
                        }
                        room {
                            name
                        }
                    }
                }
            }
        `,
        photosRef
    );

    const photoEdges = photos?.edges || [];
    const photoNode = photoEdges[modalPhotoIndex]?.node || null;

    return (
        <PhotoContainerWrapper>
            {photoNode && <PhotoContainer shouldShowImage photo={photoNode} />}
            <PhotosSearchBrowseSocialIcons photo={photoNode} photos={photos} userId={userId} />
            <PhotoPositionIndicator photoCount={totalResults} photoIndex={currentPhotoIndex} />
        </PhotoContainerWrapper>
    );
};

export default PhotosSearchBrowsePhotoContainer;
